import { render, staticRenderFns } from "./ModalConfirmRedeem.vue?vue&type=template&id=879b22f0&scoped=true"
import script from "./ModalConfirmRedeem.vue?vue&type=script&lang=js"
export * from "./ModalConfirmRedeem.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmRedeem.vue?vue&type=style&index=0&id=879b22f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879b22f0",
  null
  
)

export default component.exports